<div class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">{{ divisionLabel }} — {{ monthLabel }} {{ year }}</h2>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <!-- Summary -->
        <div class="sectiontitle sectiontitle--first">
            <h3>Summary</h3>
        </div>
        <ul class="list__specs">
            <li>
                <label>Revenue</label>
                <strong>{{ formatCurrency(amount) }}</strong>
            </li>
            <li *ngIf="target > 0">
                <label>Target</label>
                <span>{{ formatCurrency(target) }}</span>
            </li>
            <li *ngIf="target > 0">
                <label>Achievement</label>
                <strong [ngClass]="{
                    'text--green': amount >= target,
                    'text--red': amount < target
                }">{{ achievement }}%</strong>
            </li>
            <li *ngIf="target > 0">
                <label>Difference</label>
                <strong [ngClass]="{
                    'text--green': difference >= 0,
                    'text--red': difference < 0
                }">{{ formatCurrency(difference) }}</strong>
            </li>
        </ul>

        <!-- Invoices -->
        <div class="sectiontitle">
            <h3>Invoices ({{ details.length }})</h3>
        </div>

        <div *ngIf="details.length === 0" class="text--grey m-b-3">
            No invoices this month.
        </div>

        <div class="table__overflow" *ngIf="details.length > 0">
            <table class="table-view table-view--compact">
                <tr>
                    <th class="sortable" (click)="sort('documentDate')">
                        Date
                        <span class="sort-icon" *ngIf="sortColumn === 'documentDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th class="sortable" (click)="sort('invoiceNumber')">
                        Invoice #
                        <span class="sort-icon" *ngIf="sortColumn === 'invoiceNumber'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th class="sortable" (click)="sort('projectName')">
                        Project
                        <span class="sort-icon" *ngIf="sortColumn === 'projectName'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th class="sortable" (click)="sort('invoiceSubject')">
                        Subject
                        <span class="sort-icon" *ngIf="sortColumn === 'invoiceSubject'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th class="sortable" (click)="sort('contactName')">
                        Contact
                        <span class="sort-icon" *ngIf="sortColumn === 'contactName'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                    </th>
                    <th class="sortable text-right" (click)="sort('amount')">
                        Amount
                        <span class="sort-icon" *ngIf="sortColumn === 'amount'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                    </th>
                </tr>
                <tr
                    *ngFor="let detail of sortedDetails"
                    [class.invoice-row--offset]="isOffset(detail)"
                    [attr.title]="isOffset(detail) ? 'Opgeheven door een creditnota/factuur voor hetzelfde project' : null"
                >
                    <td>{{ detail.documentDate || '-' }}</td>
                    <td>{{ detail.invoiceNumber || '-' }}</td>
                    <td>{{ detail.projectName }}</td>
                    <td>{{ detail.invoiceSubject || '-' }}</td>
                    <td>{{ detail.contactName || '-' }}</td>
                    <td class="text-right">
                        <strong>{{ formatCurrency(detail.amount) }}</strong>
                    </td>
                </tr>
            </table>
        </div>
        <!-- Yuki Transactions -->
        <div class="sectiontitle" *ngIf="yukiTransactions.length > 0">
            <h3>Yuki Boekhouding ({{ yukiTransactions.length }}) — {{ formatCurrency(yukiTotal) }}</h3>
        </div>

        <div class="table__overflow" *ngIf="yukiTransactions.length > 0">
            <table class="table-view table-view--compact yuki-table">
                <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th class="text-right">Amount</th>
                </tr>
                <tr *ngFor="let tx of yukiTransactions">
                    <td>{{ tx.date }}</td>
                    <td>{{ tx.description || '-' }}</td>
                    <td class="text-right">
                        <strong>{{ formatCurrency(tx.amount) }}</strong>
                    </td>
                </tr>
            </table>
        </div>

        <!-- Difference Analysis -->
        <div class="difference-panel m-t-3" *ngIf="hasDifference">
            <div class="d-flex align-items-center" style="gap: 1rem;">
                <span class="text--red">
                    <i class="las la-exclamation-triangle"></i>
                    Verschil: <strong>{{ formatCurrency(amount - yukiTotal) }}</strong>
                    (Resumo: {{ formatCurrency(amount) }} — Yuki: {{ formatCurrency(yukiTotal) }})
                </span>
                <button class="button button--outline button--small" (click)="analyzeDifference()" [disabled]="analyzing">
                    <i class="las la-robot m-r-1" *ngIf="!analyzing"></i>
                    <i class="las la-spinner la-spin m-r-1" *ngIf="analyzing"></i>
                    {{ analyzing ? 'Analyseren...' : 'Analyseer verschil (AI)' }}
                </button>
            </div>
        </div>

        <!-- AI Analysis Card -->
        <div class="ai-card m-t-3" *ngIf="hasDifference">
            <div class="ai-card__inner">
                <div class="ai-card__header">
                    <span class="ai-card__icon">🤖</span>
                    <span *ngIf="!hasAnalysis && !analyzing" class="ai-card__placeholder">Er is nog geen analyse...</span>
                    <span *ngIf="analyzing" class="ai-card__placeholder">
                        <i class="las la-spinner la-spin"></i> Analyse wordt uitgevoerd...
                    </span>
                    <span *ngIf="hasAnalysis" class="ai-card__title">AI Analyse</span>
                </div>
                <div class="ai-card__content" *ngIf="hasAnalysis" [innerHTML]="analysisHtml"></div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="button button--outline" (click)="activeModal.dismiss()">Close</button>
    </div>
</div>
